import WorkerService from "../../WorkerService"

const
    FETCHING_RECORDS = "FETCHING_RECORDS",
    FETCHING_RECORDS_SUCCESS = "FETCHING_RECORDS_SUCCESS",
    FETCHING_RECORDS_ERROR = "FETCHING_RECORDS_ERROR",
    CLEAR_RECORDS = "CLEAR_RECORDS"

const initialState = {
    isLoading: false,
    isDeleting: false,
    isCreating: false,
    records: [],
    error: null
}

export const state = {...initialState}

export const actions = {


    async findOrderAttachments({commit}, id) {
        try {
            commit(FETCHING_RECORDS)
            let response = await WorkerService.findOrderAttachments(id)
            commit(FETCHING_RECORDS_SUCCESS, response.data)
            return response.data
        } catch (error) {
            commit(FETCHING_RECORDS_ERROR, error)
            return Promise.reject(error)
        }
    },

    async clearRecords({commit}) {
            commit(CLEAR_RECORDS)
    }

}

export const mutations = {

    [FETCHING_RECORDS](state) {
        state.isLoading = true
        state.error = null
        state.records = []
    },
    [FETCHING_RECORDS_SUCCESS](state, data) {
        state.isLoading = false
        state.error = null
        state.records = data
    },
    [FETCHING_RECORDS_ERROR](state, error) {
        state.isLoading = false
        state.error = error
        state.records = []
    },

    [CLEAR_RECORDS](state) {
        state.isLoading = false
        state.records = []
    }

}

export const getters = {

    isLoading(state) {
        return state.isLoading
    },
    hasError(state) {
        return state.error !== null
    },
    error(state) {
        return state.error
    },
    hasRecords(state) {
        return state.records.length > 0
    },
    getRecords(state) {
        return state.records
    }

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
